import { render, staticRenderFns } from "./Help__id.vue?vue&type=template&id=db396762&scoped=true&"
import script from "./Help__id.vue?vue&type=script&lang=js&"
export * from "./Help__id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db396762",
  null
  
)

export default component.exports